define(["require", "exports"], function (require, exports) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    var RoomOverview = (function () {
        function RoomOverview() {
            this.RoomId = "";
            this.Groups = [];
        }
        return RoomOverview;
    }());
    exports.RoomOverview = RoomOverview;
    var VirtualScreenGroup = (function () {
        function VirtualScreenGroup() {
            this.VirtualScreens = [];
        }
        return VirtualScreenGroup;
    }());
    exports.VirtualScreenGroup = VirtualScreenGroup;
    var VirtualScreenWithPosition = (function () {
        function VirtualScreenWithPosition() {
        }
        return VirtualScreenWithPosition;
    }());
    exports.VirtualScreenWithPosition = VirtualScreenWithPosition;
});
//# sourceMappingURL=RoomOverview.js.map


//////////////////
// WEBPACK FOOTER
// ./wwwroot/js/Models/Configuration/RoomOverview.js
// module id = 111
// module chunks = 0